<template>
  <div class="contain">
    <div class="icon">
      <Badge status="processing" :color="color" />
    </div>
    <div class="content">
      <div class="row">
        <div class="left color1">
          <Icon type="md-pricetag" />{{row.waybillNo}}
        </div>
      </div>
      <div class="row">
        <div class="right color2">
          <Icon type="md-megaphone" />{{stateLabel}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dics from '../dics.js'
export default {
  name: 'Order',
  components: {},
  props: {
    row: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function() {
        return {}
      }
    },
  },
  data() {
    return {
      color: '',
      stateLabel: ''
    }
  },
  computed: {},
  watch: {
    row: {
      handler(newName, oldName) {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.init()
  },

  methods: {
    init() {
      let state = this.row.state
      this.state2color(state)
      this.state2label(state)
    },
    state2label(state) {
      let label = ''
      dics.stateData.forEach((item) => {
        if (String(state) === String(item.value)) {
          label = item.label
        }
      })
      this.stateLabel = label
    },
    state2color(state) {
      let color = ''
      let stateInt = parseInt(state)
      switch (stateInt) {
        case 0:
          color = 'blue'
          break
        case 10:
          color = 'red'
          break
        default:
          color = 'blue'
      }
      this.color = color
    },
  }
}

</script>
<style scoped lang="less">
.contain {
  display: flex;
  flex-direction: row;
}

.contain .icon {
  flex-basis: 20px;
  display: flex;
  align-items: center;
}

.contain .content {
  flex: 1;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.row .left,
.row .right {
  flex: 1;
  font-size: 13px;
}

.color1 {
  color: rgba(0, 0, 0, 0.65);
}

.color2 {
  color: rgba(0, 0, 0, 0.45);
}

</style>
